import { IconProps } from "@radix-ui/react-icons/dist/types";
import * as React from "react";

export const PaperclipIcon = React.memo(function ({
  color = "currentColor",
  ...props
}: IconProps) {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8.5 5.5L5.75 8.25C5.33579 8.66421 5.33579 9.33579 5.75 9.75V9.75C6.16421 10.1642 6.83579 10.1642 7.25 9.75L11.5 5.5C12.3284 4.67157 12.3284 3.32843 11.5 2.5V2.5C10.6716 1.67157 9.32843 1.67157 8.5 2.5L3.12132 7.87868C1.94974 9.05026 1.94975 10.9497 3.12132 12.1213L3.37868 12.3787C4.55025 13.5503 6.44975 13.5503 7.62132 12.3787L13 7"
        stroke={color}
      />
    </svg>
  );
});
